import React from 'react';

const ActivitiesFlower = () => {
  return (
    <section id="activities-flower">

      <h1>Virágbolt</h1>

      <div id="activities-flower-columns">

        <div id="activities-flower-left">

        </div>

        <div id="activities-flower-right">

          <header>

            <div>
              <h2>Nyitvatartás:</h2>
              <ul>
                <li>H-P 9.00-12.00 </li>
                <li>13.00-17.00</li>
                <li>Sz 9.00-12.00</li>
                <li>V Zárva</li>
                    
              </ul>
            </div>

            <div>
              <h2>Elérhetőség:</h2>
              <ul>
                <li><a href="tel: +36 20-211-9207">20-211-9207</a></li>
              </ul>
            </div>

          </header>

          <p className="no-indent">
            A temetkezési üzletágban meglévő virágkötészeti tevékenység továbbfejlesztéseként 2017. március 13-án megnyitottuk virágboltunkat a Kálvin u. 2. szám alatt. A feladatot 2 fő alkalmazott látja el sok éves tapasztalattal. Kínálatunkban szerepelnek vágott- és cserepes virágok, ajándéktárgyak, koszorúk, komplett rendezvény dekorációk.
            <br/>
            Széles választékkal, modern, barátságos környezetben várjuk meglévő és új vásárlóinkat.
          </p>

        </div>

      </div>

    </section>
  );
};

export default ActivitiesFlower;